import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import AddTeamMembers from "./AddTeamMembers";

export default function EditTeamMembers() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <AddTeamMembers
      isEdit={true}
      sectionId={id}
      onSuccess={() => navigate("/list-team-members")}
    />
  );
}